// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  transition: background-color 300ms ease-in-out;
}

.bouncing-loader {
  display: flex;
}

.bouncing-loader > div {
  width: 7px;
  height: 7px;
  margin: 5px 2px;
  border-radius: 50%;
  background-color: #a3a1a1;
  opacity: 1;
  animation: bouncing-loader 0.6s infinite alternate;
}

@keyframes bouncing-loader {
  to {
    opacity: 0.2;
    transform: translateY(-7px);
  }
}

.hidden-text {
  opacity: 0;
}

.highlight {
  background-color: transparent;
  transition: background-color 0.3s ease-in-out;
}

.highlight-active {
  background-color: rgba(255, 255, 255, 0.3);
}

.bouncing-loader > div:nth-child(2) {
  animation-delay: 0.2s;
}

.bouncing-loader > div:nth-child(3) {
  animation-delay: 0.4s;
}
/*
 * Types for type identifiers and layout.
 * Used by nodes and typewrappers to inform visualization.
 */

.type {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  display: inline-flex;
  flex-direction: row;
  white-space: pre;
}

.type-breakline {
  display: flex;
  flex-direction: column;
  white-space: pre;
}

.expression {
  color: rgb(0, 105, 124);
  white-space: pre;
  font-weight: bolder;
}

.variable {
  color: rgb(89, 129, 88);
  font-weight: bolder;
  white-space: pre;
}

.typeGroup {
  display: inline-flex;
  flex-direction: column;
  white-space: pre;
}

.data {
  color: rgb(255, 255, 255);
  font-family: monospace;
  white-space: pre;
  background-color: rgb(51, 51, 51);
}

.popover {
  margin: 20px;
}

.curryfunction,
.functiontype,
.function {
  color: rgb(255, 184, 159);
}

.curryfunction.highlighted,
.functiontype.highlighted,
.function.highlighted {
  color: black;
  background-color: rgb(255, 215, 201);
}

.type.sigma {
  color: rgb(64, 178, 178);
}

.sigma.highlighted {
  color: black;
  background-color: aqua;
}

.element {
  color: red;
}

.element.highlighted {
  color: black;
  background-color: rgb(255, 165, 165);
}

.invoke {
  color: rgb(120, 200, 0);
}

.invoke.highlighted {
  color: black;
  background-color: greenyellow;
}

.invoke.nested.highlighted {
  color: black;
  background-color: rgb(219, 255, 166);
}

.pi {
  color: rgb(136, 136, 255);
}

.pi.highlighted {
  color: black;
  background-color: rgb(175, 175, 255);
}

.typenode.highlighted {
  color: rgb(85, 85, 85);
}

.typenode.highlighted {
  color: black;
  background-color: rgb(207, 207, 207);
}

.conjunction {
  color: rgb(187, 114, 255);
}

.conjunction.highlighted {
  color: black;
  background-color: rgb(223, 189, 255);
}

.conjunction.nested.highlighted {
  color: black;
  background-color: rgb(239, 221, 255);
}

.reference {
  color: rgb(54, 133, 104);
}

.reference.highlighted {
  color: black;
  background-color: rgb(129, 184, 164);
}

.variable {
  color: rgb(0, 64, 75);
}

.variable.highlighted {
  color: rgb(0, 217, 255);
}

.highlighted {
  color: black;
  background-color: blanchedalmond;
}

/* This will cause all types that are a direct descendant of a type-breakline
* to be indented by .2 em (roughly 1/5th of a character) at each level.
*/
.type > .type-breakline {
  margin-left: 0.2em;
}

.shine {
  position: relative;
  overflow: hidden;
}

.shine:before {
  content: "";
  position: absolute;
  top: 0;
  left: -275px;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  transform: skewX(-35deg);
  transition: 0.2s;
  transition-timing-function: ease-in-out;
}

.shine:hover:before {
  left: 250px;
  background: rgba(255, 255, 255, 0.1);
}

.MuiTooltip-popper {
  z-index: 50 !important;
}

.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

/* Mermaid nodes */
.nodeLabel {
  /* Prevent selecting */
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.mermaid img {
  width: auto !important;
  margin: 0 auto !important;
}

.mermaid {
  display: flex !important;
  justify-content: center !important;
}

.overflow-indent {
  text-indent: -1.5em;
  padding-left: 1.5em;
}
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE;IACE,YAAY;IACZ,2BAA2B;EAC7B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;AACA;;;EAGE;;AAEF;EACE,4DAA4D;EAC5D,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;;CAEC;AACD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,wBAAwB;EACxB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,WAAW;EACtC,qBAAqB,EAAE,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;AACzC;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,yBAAyB,EAAE,WAAW;EACtC,qBAAqB,EAAE,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;AACzC;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":["body {\n  transition: background-color 300ms ease-in-out;\n}\n\n.bouncing-loader {\n  display: flex;\n}\n\n.bouncing-loader > div {\n  width: 7px;\n  height: 7px;\n  margin: 5px 2px;\n  border-radius: 50%;\n  background-color: #a3a1a1;\n  opacity: 1;\n  animation: bouncing-loader 0.6s infinite alternate;\n}\n\n@keyframes bouncing-loader {\n  to {\n    opacity: 0.2;\n    transform: translateY(-7px);\n  }\n}\n\n.hidden-text {\n  opacity: 0;\n}\n\n.highlight {\n  background-color: transparent;\n  transition: background-color 0.3s ease-in-out;\n}\n\n.highlight-active {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n.bouncing-loader > div:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.bouncing-loader > div:nth-child(3) {\n  animation-delay: 0.4s;\n}\n/*\n * Types for type identifiers and layout.\n * Used by nodes and typewrappers to inform visualization.\n */\n\n.type {\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  display: inline-flex;\n  flex-direction: row;\n  white-space: pre;\n}\n\n.type-breakline {\n  display: flex;\n  flex-direction: column;\n  white-space: pre;\n}\n\n.expression {\n  color: rgb(0, 105, 124);\n  white-space: pre;\n  font-weight: bolder;\n}\n\n.variable {\n  color: rgb(89, 129, 88);\n  font-weight: bolder;\n  white-space: pre;\n}\n\n.typeGroup {\n  display: inline-flex;\n  flex-direction: column;\n  white-space: pre;\n}\n\n.data {\n  color: rgb(255, 255, 255);\n  font-family: monospace;\n  white-space: pre;\n  background-color: rgb(51, 51, 51);\n}\n\n.popover {\n  margin: 20px;\n}\n\n.curryfunction,\n.functiontype,\n.function {\n  color: rgb(255, 184, 159);\n}\n\n.curryfunction.highlighted,\n.functiontype.highlighted,\n.function.highlighted {\n  color: black;\n  background-color: rgb(255, 215, 201);\n}\n\n.type.sigma {\n  color: rgb(64, 178, 178);\n}\n\n.sigma.highlighted {\n  color: black;\n  background-color: aqua;\n}\n\n.element {\n  color: red;\n}\n\n.element.highlighted {\n  color: black;\n  background-color: rgb(255, 165, 165);\n}\n\n.invoke {\n  color: rgb(120, 200, 0);\n}\n\n.invoke.highlighted {\n  color: black;\n  background-color: greenyellow;\n}\n\n.invoke.nested.highlighted {\n  color: black;\n  background-color: rgb(219, 255, 166);\n}\n\n.pi {\n  color: rgb(136, 136, 255);\n}\n\n.pi.highlighted {\n  color: black;\n  background-color: rgb(175, 175, 255);\n}\n\n.typenode.highlighted {\n  color: rgb(85, 85, 85);\n}\n\n.typenode.highlighted {\n  color: black;\n  background-color: rgb(207, 207, 207);\n}\n\n.conjunction {\n  color: rgb(187, 114, 255);\n}\n\n.conjunction.highlighted {\n  color: black;\n  background-color: rgb(223, 189, 255);\n}\n\n.conjunction.nested.highlighted {\n  color: black;\n  background-color: rgb(239, 221, 255);\n}\n\n.reference {\n  color: rgb(54, 133, 104);\n}\n\n.reference.highlighted {\n  color: black;\n  background-color: rgb(129, 184, 164);\n}\n\n.variable {\n  color: rgb(0, 64, 75);\n}\n\n.variable.highlighted {\n  color: rgb(0, 217, 255);\n}\n\n.highlighted {\n  color: black;\n  background-color: blanchedalmond;\n}\n\n/* This will cause all types that are a direct descendant of a type-breakline\n* to be indented by .2 em (roughly 1/5th of a character) at each level.\n*/\n.type > .type-breakline {\n  margin-left: 0.2em;\n}\n\n.shine {\n  position: relative;\n  overflow: hidden;\n}\n\n.shine:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -275px;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.1);\n  transform: skewX(-35deg);\n  transition: 0.2s;\n  transition-timing-function: ease-in-out;\n}\n\n.shine:hover:before {\n  left: 250px;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.MuiTooltip-popper {\n  z-index: 50 !important;\n}\n\n.prevent-select {\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n}\n\n/* Mermaid nodes */\n.nodeLabel {\n  /* Prevent selecting */\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n}\n\n.mermaid img {\n  width: auto !important;\n  margin: 0 auto !important;\n}\n\n.mermaid {\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.overflow-indent {\n  text-indent: -1.5em;\n  padding-left: 1.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
